import { Component, OnInit ,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { CryptoJsService } from './../../services/crypto-js.service';

import { first } from 'rxjs/internal/operators/first';

import { Message, MessageService } from 'primeng/api';

import { ActivatedRoute, Router } from '@angular/router';

import * as CryptoJS from 'crypto-js';
import { MenuService } from 'src/app/services/app.menu.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { SuperAdminService } from 'src/app/services/super-admin.service';
import { ConfirmationService } from 'primeng/api';
import { ViewEncapsulation } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

import { FileUpload } from 'primeng/fileupload';




// GeoMapping row interface
export interface GeoMappingRow {
  userID?: string;
  mappingType?: string;
  districtID?: string;
  districtName?: string;
  blockID?: string;
  blockName?: string;
  villageID?: string;
  villageName?: string;
  actionID?: string;
  actionName?: string;

  blocks?: any[];
  villages?: any[];
  enableDistrict?: boolean;
  enableBlock?: boolean;
  enableVillage?: boolean;
   // ✅ Add these two new flags
  isReadOnlyMapping?: boolean;
  isReadOnlyDistrict?: boolean;
  
}





@Component({
  selector: 'app-user-mapping',
  templateUrl: './user-mapping.component.html',
  styleUrls: ['./user-mapping.component.scss'],
   encapsulation: ViewEncapsulation.Emulated // ✅ default (keeps CSS local)
})
export class UserMappingComponent implements OnInit {
@ViewChild('fileUploader') fileUploader!: FileUpload;


  geoMappings: GeoMappingRow[] = [];
  actions: any[] = [];
  districts: any[] = [];
  blocks: any[] = [];
  villages: any[] = [];
  generatedLoginDetails: any;


  officerForm: FormGroup;
  submitted = false;
  selectedRoleType: string = '';
  roles: any[] = []; // this will store dropdown data
  //actions: any[] = [];


  userLoginForm!: FormGroup;
  userBlockForm: FormGroup;
  registeredForm: FormGroup;


  userLoginData: any[] = [];

  editingUserId: string | null = null;
  geoMappingForm: FormGroup;



  combinedForm!: FormGroup;
  selectedGeoType: string = '';

  generatedUserId: string | null = null;
  displayDialog = false;

  geoMappingResults: any[] = [];
  searchUserId: string = '';
  loading: boolean = false;


  selectedFormType: string = 'newUser';  // default

  selectedGeoTypeReg: string = '';
  showLoginPanel: boolean = false;


  loginForm!: FormGroup; // ✅ declare the form


  // geoMappings!: FormArray;
  mappingForm!: FormGroup;

  userDetails: any[] = []; // load from API





  // For contact update modal
  showContactModal = false;
  selectedUser: any = null;
  selectedUpdateType: string = '';

  updateOptions = [
    { label: 'Mobile', value: 'mobile' },
    { label: 'Email', value: 'email' },
    { label: 'Both', value: 'both' }
  ];


  //generatedLoginDetails: any;
  geoMapping: any = {
    actionID: '',
    districtID: '',
    blockID: '',
    villageID: '',
  };


  // Inside your component class
  filteredActions: any[] = [];

  showMappingModal = false;
  mappingUserID: string = '';

  // 🔓 Unlock user state
  showUnlockModal: boolean = false;
  selectedUserLockout: any = null;
  //selectedUserLockout: any = null;
  showLockoutModal: boolean = false;

  usersLockout: any[] = [];

  // Track current edited user for top section
  editedUser: any = null;
  showEditModal: boolean = false;


temporaryOfficerData: any = null;
temporaryLoginData: any = null;
showMappingSection = false;
isGeoAccordionOpen = false; // collapsed initially


filteredGeoMappings: any[] = [];


uploadedFile: File | null = null;
uploadedFileName: string = '';
newUserID: string | null = null;
showSuccessDialog = false;

uploadedFilePreview: string | null = null;
uploadedFileType: 'pdf' | 'image' | null = null;
isDistrictLocked: boolean = false; // ✅ Add this line
showActionOnlyMessage = false;
public userID: string = '';
public adminLogin: boolean = false;



  constructor(

     private messageService: MessageService,
    private fb: FormBuilder,
    public router: Router,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
    private adminservice: SuperAdminService,
    private confirmserv: ConfirmationService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef

  ) { }



  ngOnInit(): void {
    this.checkAdminLogin();
  console.log('✅ Admin Login:', this.adminLogin); // true or false
  console.log('👤 UserID:', this.userID);

    this.geoMappings = [
      { userID: '', mappingType: '', districtID: '', blockID: '', villageID: '' },
    ];



    // 🔹 Initialize forms
    this.officerForm = this.fb.group({
      officerName: ['', Validators.required],
      emailId: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });

    this.loginForm = this.fb.group({
      roleID: ['', Validators.required],
      districtID: ['', Validators.required],
    });



    this.combinedForm = this.fb.group({
      Mobile: ['', Validators.required],
    
      Roletype: ['', Validators.required],
      userPass: ['', Validators.required],
      userType: ['', Validators.required],   // actionId
      geoType: ['', Validators.required],
      district: [''],
      block: [''],
      village: ['']
    });

    this.registeredForm = this.fb.group({
      UserID: ['', Validators.required],
      geoType: ['', Validators.required],
      actionType: ['', Validators.required],
      district: [''],
      block: [''],
      village: ['']
    });


    this.geoMappingForm = this.fb.group({
      userId: [{ value: this.userLoginForm?.value?.userId || '', disabled: true }],
      geoType: ['', Validators.required],
      district: [''],
      block: [''],
      village: ['']
    });

    this.officerForm = this.fb.group({
      officerName: ['', Validators.required],
      emailId: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });

    // Initialize reactive form
    this.userLoginForm = this.fb.group({
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      userId: ['', Validators.required],
      roleId: [null, Validators.required],
      userPass: ['', Validators.required]
    });

    //add mapping
    this.userBlockForm = this.fb.group({
      userId: [{ value: this.userLoginForm.value.userId, disabled: true }, Validators.required],
      block: ['', Validators.required]
    });

    this.loadDistricts();
    this.loadRoles();
    this.loadActions();
    this.geoMappingForm = this.fb.group({
      geoMappings: this.fb.array([this.createMappingRow()])
    });

    this.loadAllGeoMappings();
  
  
  
  }

 checkAdminLogin(): void {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        console.warn('No token in sessionStorage');
        return;
      }

      console.log('🔑 Raw Token:', token);

      // Decrypt token
      const decrypted = this.cryptoJsService.DecryptToken(token);
      console.log('🔑 Decrypted Token:', decrypted);

      const tokenObj = JSON.parse(decrypted);

      // Parse the `id` property (contains actual user info)
      if (!tokenObj.id) {
        console.warn('No id found in token');
        return;
      }

      const userData = JSON.parse(tokenObj.id);
      console.log('🔑 User Data from id:', userData);

      this.userID = userData.UserId || '';
      this.adminLogin = userData.RoleName === 'ADMIN';

      console.log('✅ Admin Login:', this.adminLogin);
      console.log('✅ UserID:', this.userID);

      // Update template
      this.cdr.detectChanges();

    } catch (err) {
      console.error('❌ Error parsing token:', err);
    }
  }

  onMappingTypeChange(row: GeoMappingRow) {
    row.enableDistrict = false;
    row.enableBlock = false;
    row.enableVillage = false;

    if (row.mappingType === 'District') {
      row.enableDistrict = true;
    } else if (row.mappingType === 'Block') {
      row.enableDistrict = true;
      row.enableBlock = true;
    } else if (row.mappingType === 'Village') {
      row.enableDistrict = true;
      row.enableBlock = true;
      row.enableVillage = true;
    }

    // Reset previous selections
    row.districtID = '';
    row.blockID = '';
    row.villageID = '';
    row.blocks = [];
    row.villages = [];
  }


  addEmptyGeoMapping() {
    this.geoMappings.push({
      mappingType: '',
      districtID: '',
      blockID: '',
      villageID: '',
      actionID: ''
    });
  }


  onDistrictChange(row: GeoMappingRow) {
    row.blockID = '';
    row.villageID = '';
    row.villages = [];

    if (row.districtID) {
      this.adminservice.GetBlockMaster(row.districtID).subscribe({
        next: (res: any) => row.blocks = res,
        error: (err) => console.error('Error fetching blocks', err)
      });
    } else {
      row.blocks = [];
    }
  }

  onBlockChange(row: GeoMappingRow) {
    row.villageID = '';
    if (row.blockID && row.districtID) {
      this.adminservice.GetVillageMaster(row.districtID, row.blockID).subscribe({
        next: (res: any) => row.villages = res,
        error: (err) => console.error('Error fetching villages', err)
      });
    } else {
      row.villages = [];
    }
  }

  confirmDeactivate(user: any) {
    this.confirmserv.confirm({
      message: `Are you sure you want to deactivate mapping for ${user.userID}?`,
      accept: () => {
        this.updateAndDeactivate(user);
      }
    });
  }

  openMappingModal(user: any) {
    this.mappingUserID = user.userID; // prefill from table user
    this.showMappingModal = true;

    // reset mapping data if needed
    this.geoMappings = [
      {
        mappingType: '',
        districtID: '',
        blockID: '',
        villageID: '',
        actionID: '',
        enableDistrict: false,
        enableBlock: false,
        enableVillage: false,
        blocks: [],
        villages: []
      }
    ];

    this.filterActionsByRole(); // optional, if you want role-based actions
  }



  addGeoMappingRow() {
    this.geoMappings.push({
      userID: this.generatedLoginDetails?.userID,
      enableDistrict: false,
      enableBlock: false,
      enableVillage: false,
      blocks: [],
      villages: []
    });
  }


  removeGeoMappingRow(index: number) {
    this.geoMappings.splice(index, 1);
  }

  createMappingRow(): FormGroup {
    return this.fb.group({
      geoType: [''],
      district: [''],
      block: [''],
      village: [''],
      actionID: ['']
    });
  }

  get geoMappingsControls() {
    return (this.geoMappingForm.get('geoMappings') as FormArray).controls;
  }



  initMappingForm() {
    // ✅ Mapping Form
    this.mappingForm = this.fb.group({
      userID: [{ value: '', disabled: true }],
      mappings: this.fb.array([this.createMappingRow()])
    });
  }
  


  addGeoMapping() {
    if (!this.geoMapping.actionID || !this.geoMapping.districtID) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Incomplete',
        detail: 'Please select at least Action and District.',
      });
      return;
    }

    const selectedAction = this.actions.find(a => a.actionID === this.geoMapping.actionID)?.actionName || '';
    const selectedDistrict = this.districts.find(d => d.Dist_Code === this.geoMapping.districtID)?.District || '';
    const selectedBlock = this.blocks.find(b => b.Block_Code === this.geoMapping.blockID)?.Block_Name || '';
    const selectedVillage = this.villages.find(v => v.Village_Code === this.geoMapping.villageID)?.Village_Name || '';

    this.geoMappings.push({
      actionID: this.geoMapping.actionID,
      districtID: this.geoMapping.districtID,
      blockID: this.geoMapping.blockID,
      villageID: this.geoMapping.villageID,
      actionName: selectedAction,
      districtName: selectedDistrict,
      blockName: selectedBlock,
      villageName: selectedVillage,
    });

    this.geoMapping = { actionID: '', districtID: '', blockID: '', villageID: '' };
  }

  removeGeoMapping(index: number) {
    this.geoMappings.splice(index, 1);
  }


  


  // user details add

  createUserLogin(): void {
    this.submitted = true;

    if (this.combinedForm.invalid) {
      this.combinedForm.markAllAsTouched();
      return;
    }

    const formVal = this.combinedForm.value;

    let geoID: string | null = null;
    if (formVal.geoType === 'District') {
      geoID = formVal.district ? formVal.district.toString().padStart(2, '0') : null;
    } else if (formVal.geoType === 'Block') {
      geoID = formVal.block;
    } else if (formVal.geoType === 'Village') {
      geoID = formVal.village;
    }

    const reqBody = {
      mobile: formVal.Mobile,
      roleID: Number(formVal.Roletype),
      userPass: formVal.userPass,
      geoID: geoID ? Number(geoID) : null,
      districtID: formVal.district ? formVal.district.toString().padStart(2, '0') : null,
      blockID: formVal.block || null,
      villageID: formVal.village || null,
      actionId: Number(formVal.userType)
    };

    this.loader.start();
    this.adminservice.InsertUserLoginGeoMapping(reqBody).pipe(first()).subscribe({
      next: (resp: any) => {
        this.loader.close();
        console.log("✅ API Success Response:", resp);

        // resp is just the UserID string like "JEBhiwani41"
        this.generatedUserId = typeof resp === 'string' ? resp.trim() : null;

        if (this.generatedUserId) {

          this.displayDialog = true; // ✅ Show popup
          this.combinedForm.reset(); // 🔄 Reset form
          this.submitted = false;
        }
      },
      error: (err) => {
        this.loader.close();
        console.error("⚠️ API Error Response:", err);
      }
    });
  }

  //Get Role
  loadRoles() {
    this.adminservice.getGetAllUserMaster().subscribe({
      next: (res) => {
        console.log('Roles API Response:', res);

        // API returns roles inside $values
        if (res.$values && Array.isArray(res.$values)) {
          this.roles = res.$values;
        } else {
          this.roles = [];
        }

        console.log('Roles after assignment:', this.roles);
      },
      error: (err) => {
        console.error('Error loading roles', err);
      }
    });
  }

  //Get Action in Table
  getActionName(actionID: any): string {
    const id = +actionID; // ensure number
    const action = this.actions.find(a => +a.actionID === id);
    return action ? action.action : actionID?.toString();
  }

  // 🔹 Fetch all geo mappings on load
loadAllGeoMappings() {
  this.loading = true;
  this.adminservice.GetAllGeoMappings().subscribe({
    next: (res: any) => {
      const data = res?.$values || res || [];

      this.geoMappingResults = data.map((item: any) => ({
        ...item,
        editMode: false
      }));

      this.filteredGeoMappings = [...this.geoMappingResults];
      this.loading = false;
    },
    error: (err) => {
      console.error('Error fetching all geo mappings:', err);
      this.loading = false;
    }
  });
}

// 🔍 Filter on typing (client-side filter)
filterByUserId() {
  const term = this.searchUserId.trim().toLowerCase();
  if (!term) {
    this.filteredGeoMappings = [...this.geoMappingResults];
  } else {
    this.filteredGeoMappings = this.geoMappingResults.filter(item =>
      item.userID?.toLowerCase().includes(term)
    );
  }
}


  // Enable / Disable edit mode
  toggleEdit(user: any) {
    if (this.editedUser === user && user.editMode) {
      user.editMode = false;
      this.editedUser = null;
      this.showEditModal = false; // close modal
      return;
    }
    this.geoMappingResults.forEach(u => u.editMode = false);
    user.editMode = true;
    this.editedUser = user;
    this.showEditModal = true; // open modal
  }

  // ✅ Confirmation before update
  confirmUpdate(user: any) {
    this.confirmserv.confirm({
      message: `Are you sure you want to update mapping for <b>${user.userID}</b>?`,
      accept: () => {
        this.updateAndDeactivate(user);
      }
    });
  }

  // ✅ Call API
  updateAndDeactivate(user: any) {
    const reqBody = {
      userID: user.userID,     // 👈 matches API (lowercase u)
      geoID: user.code,        // 👈 assuming GeoID is in `code` column
      actionID: +user.actionID // 👈 ensure number (your API requires int)
    };

    console.log("📤 Sending payload:", reqBody);

    this.adminservice.UpdateUserGeoMapping(reqBody).subscribe({
      next: (resp: any) => {
        console.log("✅ API Response:", resp);

        this.messageService.add({
          severity: 'success',
          summary: 'Updated',
          detail: `Mapping for ${user.userID} Deactivate successfully`
        });

        // reset edit mode
        user.editMode = false;
        // 🔄 Refresh table after update
        //this.searchGeoMapping();
      },
      error: (err) => {
        console.error('❌ UpdateUserGeoMapping API Error:', err);

        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: err?.error?.error || 'Could not update mapping'
        });
      }
    });
  }

 
  loadActions() {
    this.adminservice.GetActions().subscribe({
      next: (res: any) => {
        this.actions = res?.$values || [];
        this.filterActionsByRole(); // filter when loaded
      },
      error: (err) => console.error('Error fetching actions', err)
    });
  }


  getAllActions() {
    return this.actions;
  }
 
  
filterActionsByRole() {
  const selectedRoleID = this.loginForm.get('roleID')?.value;

  // ✅ Reset by default
  this.isDistrictLocked = false;
  this.showActionOnlyMessage = false;
  if (!selectedRoleID) {
    this.filteredActions = [];
  } else {
    const roleActionMap: { [key: string]: number[] } = {
      '8': [5, 10, 18],
      '9': [5, 10, 18],
      '10': [5, 10, 18],
      '6': [13, 2, 19]
    };

    const allowedActions = roleActionMap[selectedRoleID?.toString()] || [];
    this.filteredActions = this.actions.filter((a: any) => allowedActions.includes(a.actionID));

    // ✅ If roleID = 8, lock Mapping Type to "District"
    if (String(selectedRoleID) === '8') {
      this.isDistrictLocked = true;
         this.showActionOnlyMessage = true;

      this.geoMappings.forEach(row => {
        row.mappingType = 'District';
        row.enableDistrict = true;
        row.enableBlock = false;
        row.enableVillage = false;
      });
    }
  }

  // Reset invalid actions
  this.geoMappings.forEach(row => {
    if (row.actionID && !this.filteredActions.find(a => a.actionID === row.actionID)) {
      row.actionID = null;
    }
  });

  this.autoOpenAccordionAndSetDistrict();
}

onDistrictChangeEvent() {
  this.autoOpenAccordionAndSetDistrict();
}

autoOpenAccordionAndSetDistrict() {
  const roleID = this.loginForm.get('roleID')?.value;
  const districtID = this.loginForm.get('districtID')?.value;

  if (roleID && districtID) {
    this.isGeoAccordionOpen = true; // ✅ open accordion only if both selected

    // Loop through mapping rows
    this.geoMappings.forEach(row => {
      // Role 8 → District mapping only (read-only)
      if (roleID == 8) {
        row.mappingType = 'District';
        row.districtID = districtID;
        row.isReadOnlyMapping = true;
        row.isReadOnlyDistrict = true;
        row.enableDistrict = false;
        row.enableBlock = false;
        row.enableVillage = false;
      } else {
        // Other roles → fully editable
        row.isReadOnlyMapping = false;
        row.isReadOnlyDistrict = false;
        row.enableDistrict = true;
        row.enableBlock = true;
        row.enableVillage = true;
      }
    });
      // ✅ Force Angular to update UI now
    this.cdr.detectChanges();
  } else {
    // If either missing, accordion stays read-only
    this.isGeoAccordionOpen = false;
    this.geoMappings.forEach(row => {
      row.isReadOnlyMapping = true;
      row.isReadOnlyDistrict = true;
    });
  }
}
// ✅ When dialog closes, reset everything
onDialogHide() {
  // Reset everything when dialog closes
  this.loginForm.reset();
  this.isGeoAccordionOpen = false;
  this.geoMappings = [
    {
      mappingType: '',
      districtID: '',
      enableDistrict: false,
      enableBlock: false,
      enableVillage: false,
      isReadOnlyMapping: false,
      isReadOnlyDistrict: false
    }
  ];
}


  

  // ✅ Load all districts
  loadDistricts() {
    this.adminservice.getGetDistrictMaster().subscribe({
      next: (res) =>
        this.districts = res?.$values ? res.$values : res,


      error: (err) => console.error('Error fetching districts', err)
    });
  }



  get mappingRows(): FormArray {
    return this.mappingForm.get('mappings') as FormArray;
  }

storeOfficerData() {
  if (this.officerForm.invalid) {
    this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill officer details.' });
    return;
  }

  this.temporaryOfficerData = { ...this.officerForm.value };
 
  this.showLoginPanel = true;
}
storeLoginData() {
  if (this.loginForm.invalid) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please select role and district before proceeding.'
    });

    // ❌ Do not open accordion when invalid
    this.isGeoAccordionOpen = false;
    //this.disableGeoMappingFields(true); // keep read-only state
    return;
  }

  // ✅ Store login data temporarily
  this.temporaryLoginData = { ...this.loginForm.value };

  // ✅ Enable accordion and mapping section
  this.isGeoAccordionOpen = true;
  //this.disableGeoMappingFields(false); // make fields editable

  // ✅ Refresh available actions based on role
  this.filterActionsByRole();

  this.messageService.add({
    severity: 'success',
    summary: 'Stored',
    detail: 'Login data stored and mapping enabled.'
  });
}
disableGeoMappingFields(isReadOnly: boolean) {
  this.geoMappings.forEach(row => {
    row.isReadOnlyDistrict = isReadOnly;
    row.enableDistrict = !isReadOnly;
    row.enableBlock = !isReadOnly;
    row.enableVillage = !isReadOnly;
  });
  this.autoOpenAccordionAndSetDistrict();

}



 onFileUpload(event: any) {
    const file = event.files[0];
    this.uploadedFile = file;
    const ext = file.name.split('.').pop()?.toLowerCase();
    this.uploadedFileType = ext === 'pdf' ? 'pdf' : 'image';
  }

  viewFile() {
    if (!this.uploadedFile) return;
    const fileURL = URL.createObjectURL(this.uploadedFile);
    window.open(fileURL, '_blank');
  }

  removeUploadedFile() {
    this.uploadedFile = null;
    this.uploadedFileType = null;
    if (this.fileUploader) {
      this.fileUploader.clear();
    }
  }


closeDialog() {

  this.newUserID = null;
  this.uploadedFile = null;
  this.loginForm.reset();
}

submitGeoMappings() {
  if (!this.geoMappings?.length) {
    this.messageService.add({
      severity: 'warn',
      summary: 'No Mappings',
      detail: 'Please add at least one mapping.'
    });
    return;
  }

  // ✅ Validate file upload
  if (!this.uploadedFile) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Missing File',
      detail: 'Please upload an Office Order file before submitting.'
    });
    return;
  }

  // ✅ Build Mapping Payload
  const mappingPayload = this.geoMappings
    .filter(row => row.mappingType && row.actionID)
    .map(row => {
      const geoID =
        row.mappingType === 'District' ? row.districtID :
        row.mappingType === 'Block' ? row.blockID :
        row.mappingType === 'Village' ? row.villageID : null;

      return {
        userID: this.generatedLoginDetails?.userID || this.mappingUserID || row.userID || 0,
        geoID: Number(geoID) || 0,
        actionID: Number(row.actionID)
      };
    });

  // ✅ Officer Payload
  const officerBody = [{
    officer_Name: this.officerForm.value.officerName?.trim(),
    emailID: this.officerForm.value.emailId?.trim(),
    mobile: this.officerForm.value.mobile?.trim()
  }];

  // ✅ Login Payload Template
  const loginBody: any = {
    office_Code: '', // Will fill after insertUserRole
    roleID: Number(this.loginForm.value.roleID),
    districtID: String(this.loginForm.value.districtID || '')
  };

  // 1️⃣ Insert Officer
  this.adminservice.insertUserRole(officerBody).subscribe({
    next: (res1: any) => {
      const parsed = typeof res1 === 'string' ? JSON.parse(res1) : res1;
      const officeCode = parsed?.[0]?.Office_code || parsed?.Office_code || '';

      if (!officeCode) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Office code not found after officer creation.'
        });
        return;
      }

          // ✅ Save in localStorage
    localStorage.setItem('Office_Code', officeCode);
    console.log('✅ Office_Code saved to localStorage:', officeCode);

      // 2️⃣ Generate Login
      loginBody.office_Code = String(officeCode); // force string
      loginBody.roleID = Number(this.loginForm.value.roleID);
      loginBody.districtID = String(this.loginForm.value.districtID || '');

      this.adminservice.generateUserLogin(loginBody).subscribe({
        next: (res2: any) => {
          const userID = res2?.newUserID || res2?.UserID || res2?.userID || null;

          if (!userID) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to generate UserID.'
            });
            return;
          }

          // 3️⃣ Insert Geo Mappings
          const finalPayload = mappingPayload.map(m => ({
            ...m,
            userID
          }));

          this.adminservice.InsertMapping(finalPayload).subscribe({
            next: (res3: any) => {
              console.log('✅ Mapping submitted successfully:', res3);
// 4️⃣ Upload Office Order
const storedOfficeCode = localStorage.getItem('Office_Code');
  const trimmedOfficeCode = storedOfficeCode ? storedOfficeCode.trim() : '';

  if (!trimmedOfficeCode) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Missing Office Code',
      detail: 'Please create a user before uploading Office Order.'
    });
    return;
  }

  if (!this.uploadedFile) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Missing File',
      detail: 'Please select an Office Order file before submitting.'
    });
    return;
  }

  // Use file name only (you’ll generate URL in backend)
  const payload = {
    office_Code: trimmedOfficeCode,
    officeOrder: this.uploadedFile.name
  };

  console.log('🚀 Sending payload:', payload);

  this.adminservice.insertOfficeOrder(payload).subscribe({
    next: (res4: any) => {
                console.log('✅ Office order uploaded:', res4);
      this.newUserID = res2?.newUserID || null;
    this.showSuccessDialog = true; // 🔸 show success popup
                  this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: `✅ User created successfully: ${userID}`
                  });

                    // ✅ Reset temporary data
    this.clearTemporaryData();
                  // ✅ Reset All Fields & Close Dialog
               setTimeout(() => {
  this.showLoginPanel = false;
  this.geoMappings = [];
  this.addGeoMappingRow();
  this.officerForm.reset();
  this.loginForm.reset();

  // ✅ Clear uploaded file state
  this.uploadedFile = null;
  this.uploadedFileType = null;
  this.uploadedFileName = '';

  // ✅ Also clear the PrimeNG file uploader UI
  if (this.fileUploader) {
    this.fileUploader.clear();
  }

  this.loadAllGeoMappings(); // Refresh list
}, 1500);

                },
                error: (err4) => {
                  console.error('❌ Office order upload failed:', err4);
                  this.messageService.add({
                    severity: 'warn',
                    summary: 'Partial Success',
                    detail: 'User created, but Office Order upload failed.'
                  });
                }
              });
            },
            error: (err3) => {
              console.error('❌ Mapping API error:', err3);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to insert Geo Mappings.'
              });
            }
          });
        },
        error: (err2) => {
          console.error('❌ Generate login error:', err2);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to generate user login.'
          });
        }
      });
    },
    error: (err1) => {
      console.error('❌ Officer creation error:', err1);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to create officer.'
      });
    }
  });
}

clearTemporaryData() {
  // Clear localStorage and component data
  localStorage.removeItem('Office_Code');
  this.geoMappings = [];
  this.addGeoMappingRow();
  this.officerForm.reset();
  this.loginForm.reset();
  this.uploadedFile = null;
  this.uploadedFileName = '';
  this.mappingUserID = null;
}

closeAllDialogs() {
  this.showSuccessDialog = false;
  this.showLoginPanel = false;
  this.clearTemporaryData();
}



resetAllForms() {
  this.officerForm.reset();
  this.loginForm.reset();
  this.geoMappings = [];
  this.showLoginPanel = false;
  this.temporaryOfficerData = null;
  this.temporaryLoginData = null;
}



  onLoginModalHide() {
   
    console.log('🔔 Dialog hide event triggered. generatedLoginDetails:', this.generatedLoginDetails);
  }

  mapRegisteredUser() {
    if (this.registeredForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill all required fields'
      });
      return;
    }

    const formValue = this.registeredForm.value;

    // ✅ Decide GeoID based on mapping type
    let geoID = null;
    if (formValue.geoType === 'District') {
      geoID = formValue.district;
    } else if (formValue.geoType === 'Block') {
      geoID = formValue.block;
    } else if (formValue.geoType === 'Village') {
      geoID = formValue.village;
    }

    const payload = {
      userID: formValue.UserID,
      geoID: geoID,
      actionID: formValue.actionType
    };

    console.log('Mapping payload:', payload);

    this.adminservice.RegisteredUserGeoMapping(payload).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          //detail: res?.message || 'User mapped successfully'
        });
        this.registeredForm.reset();
        this.blocks = [];
        this.villages = [];
        // ✅ Close modal and section
        this.showContactModal = false;
        this.editedUser = null; this.editedUser = true;
        this.editedUser = null;  // 👈 closes the section

        this.showContactModal = false;
        //this.searchGeoMapping(); // refresh grid

      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.error || 'Mapping failed'
        });
      }
    });
  }




  openContactModal(user: any) {
    this.selectedUser = { ...user }; // clone
    this.selectedUpdateType = ''; // nothing chosen yet
    this.showContactModal = true;
  }
  
  onUpdateTypeChange(value: string) {
    this.selectedUpdateType = value;
  }
  
  
  updateContactInfo() {
    if (!this.selectedUpdateType) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Select Option',
        detail: 'Please choose what to update.'
      });
      return;
    }
  
    const reqBody = {
      userID: this.selectedUser.userID,
      mobile: this.selectedUser.mobile,
      emailID: this.selectedUser.emailID
    };
  
    this.adminservice.UpdateUserContact(reqBody).subscribe({
      next: (resp) => {
        const message = resp?.Message || 'Updated Successfully';
        this.messageService.add({
          severity: 'success',
          summary: 'Updated',
          detail: `Contact info updated for ${reqBody.userID} - ${message}`
        });
        this.showContactModal = false;
      
      },
      error: (err) => {
        const msg = err?.error?.Message || 'Failed to update contact info';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: msg
        });
      }
    });
  }
  

  submitGeoMappingsFromModal() {
    const payload = this.geoMappings.map(row => {
      let geoID: number = 0;

      if (row.mappingType === 'District') geoID = Number(row.districtID);
      else if (row.mappingType === 'Block') geoID = Number(row.blockID);
      else if (row.mappingType === 'Village') geoID = Number(row.villageID);

      return {
        userID: row.userID,
        geoID: geoID || 0,
        actionID: Number(row.actionID) || 0
      };
    });

    // ✅ Call already working API
    this.adminservice.insertMapping(payload).subscribe({
      next: (res: any) => {
        console.log('✅ Insertmapping success:', res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Geo mapping submitted successfully!'
        });

      // ✅ Exit edit mode for this user
      if (this.selectedUserLockout) {
        this.selectedUserLockout.editMode = false;
      }
      this.showUnlockModal = false;
      this.editedUser = true;
      this.showMappingModal=false;
      this.showLoginPanel=false;
      //this.searchLockout();
// ✅ Close modal and section
this.showContactModal = false;
this.editedUser = null;     
        
      },
      error: (err: any) => {
        console.error('❌ Insertmapping failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to submit mapping!'
        });
      }
    });
  }

  // 🔹 Search user lockout
  searchLockout() {
    if (!this.searchUserId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a UserID' });
      return;
    }

    this.adminservice.searchUserLockout(this.searchUserId).subscribe({
      next: (res) => {
        // Wrap response in array to bind to table
        this.usersLockout = [res];
      },
      error: (err) => {
        console.error('Error fetching lockout details', err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'User not found or API error' });
        this.usersLockout = [];
      }
    });
  }




  // 🔹 Set user before confirming
  setSelectedUser(user: any) {
    this.selectedUserLockout = user;
    this.confirmUnlockUser(); // Open confirm popup immediately
  }

  // 🔹 Confirm Unlock Popup
  confirmUnlockUser() {
    if (!this.selectedUserLockout?.userID) return;

    this.confirmserv.confirm({
      message: 'Are you sure you want to unlock this account?',
      header: 'Confirm Unlock',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes, Unlock',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.unlockUser(); // Call API only when confirmed
      }
    });
  }

  // 🔹 Unlock user API call
  unlockUser() {
    const userID = this.selectedUserLockout?.userID;
    if (!userID) return;

    this.adminservice.unlockUser(userID).subscribe({
      next: (res: string) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res, // will show "Successfully Unlocked the account."
        });

        // ✅ Exit edit mode for this user
        if (this.selectedUserLockout) {
          this.selectedUserLockout.editMode = false;
        }
        this.showUnlockModal = false;
        this.editedUser = true;
 
 // ✅ Close modal and section
 this.showContactModal = false;
 this.editedUser = null;
        
      },
      error: (err) => {
        //console.error('Error unlocking user', err);
        this.messageService.add({
          severity: 'success',
          summary: 'success',
          detail: err?.message || '"Successfully Unlocked the account',
        });
      }
    });


  }
// Return color for Area Type
getGeoRowColor(geoType: string): string {
  switch (geoType?.toLowerCase()) {
    case 'district':
      return '#ffcccc'; // Light Red
    case 'block':
      return '#cce5ff'; // Light Blue
    case 'village':
      return '#ccffcc'; // Light Green
    case 'other':
      return '#e6f7ff'; // Soft Blue
    default:
      return 'transparent';
  }
}
submitGeoMappingsForRegisterUser() {
  if (!this.geoMappings?.length) {
    this.messageService.add({
      severity: 'warn',
      summary: 'No Mappings',
      detail: 'Please add at least one mapping.'
    });
    return;
  }

  // ✅ Build Mapping Payload
  const mappingPayload = this.geoMappings
    .filter(row => row.mappingType && row.actionID)
    .map(row => {
      const geoID =
        row.mappingType === 'District' ? row.districtID :
        row.mappingType === 'Block' ? row.blockID :
        row.mappingType === 'Village' ? row.villageID : null;

      return {
        userID: this.mappingUserID || row.userID || 0,
        geoID: Number(geoID) || 0,
        actionID: Number(row.actionID)
      };
    });

  // 1️⃣ Insert Geo Mappings only
  this.adminservice.InsertMapping(mappingPayload).subscribe({
    next: (res) => {
      console.log('✅ Mappings submitted:', res);
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Geo mappings submitted successfully!'
      });

      // Reset form & mappings
      this.geoMappings = [];
      this.addGeoMappingRow();
       this.loadAllGeoMappings(); // Refresh list
    },
    error: (err) => {
      console.error('❌ Mapping insert failed:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to insert geo mappings.'
      });
    }
  });
}


}
